import ServiceDetail from '../components/services/ServiceDetail';

export default function Branding() {
    return <ServiceDetail id="branding" itemPrefix="bi" count={6} heroTestid="branding-hero" gridTestid="branding-servicios" ctaTestid="branding-cta" />;
}
